import React, { useEffect, useState } from 'react';
import { ValidMe } from '../../../../businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import { Label, Checkbox } from 'semantic-ui-react';
var passwordValidator = require('../../../../businessLogic/resetPasswordValidation');
import { setUserSignupForm, resetUserSignupForm, createSignup, validateUserSignupLink } from 'actions/user';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { displayGlobalMessage } from '../../../../actions/globalMessage';
import { redirectToInternalLink } from 'businessLogic/redirector.js';
import objectAssign from 'object-assign';
import momentTimezone from 'moment-timezone/builds/moment-timezone-with-data-2012-2022.min';
import { setAuthenticationDetails, getUrlParameter } from '../../../../businessLogic/authorizator.js';
import jwtDecode from 'jwt-decode';
import { useDispatch } from 'react-redux';

const ContentUserSignUp = (props) => {
  let emailId = getUrlParameter('emailid');
  const decodeEmail = (emailId) => {
    try {
      let emailDecoded = '';
      if (emailId) {
        emailDecoded = jwtDecode(emailId).payload;
      }
      return emailDecoded;
    } catch (ex) {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.ServerErrors.InvalidUserSignupRequest,
          visible: true,
          messageType: 'Bad',
        })
      );
      redirectToInternalLink('/login'); //we do not want the login page to refresh
    }
  };
  const dispatch = useDispatch();
  const [isUserSignupSaving, setIsUserSignupSaving] = useState(false);
  const [email, setEmail] = useState(decodeEmail(emailId));
  const [jwtEmail, setJwtEmail] = useState(emailId);
  const [isValid, setIsValid] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [timeZone, setTimeZone] = useState(momentTimezone.tz.guess()); //we set the timezone initially
  const [agreeTermsAndCondition, setAgreeTermsAndCondition] = useState(false);
  const [loadingClass, setLoadingClass] = useState('');
  let passwordValue = '';

  useEffect(() => {
    setLoadingClass('');
    let emailId = getUrlParameter('emailid');
    if (!email || email == '') {
      setJwtEmail(emailId);
      setEmail(decodeEmail(emailId));
    }
    //register the delegate event

    let cb = (result) => {
      window.$('#overlay').fadeOut();
      if (!result) {
        redirectToInternalLink('/login'); //we do not want the login page to refresh
      } else {
        setIsValid(true);
      }
    };
    window.$('#overlay').show();

    dispatch(validateUserSignupLink(emailId, cb));
  }, []);

  const firstNameChanged = (val) => {
    setFirstName(val);
  };
  const lastNameChanged = (val) => {
    setLastName(val);
  };
  const passwordChanged = (val) => {
    val = passwordValidator.removeInvalidChars(val);
    setPassword(val);
  };
  const retypePasswordChanged = (val) => {
    setConfirmPassword(val);
  };

  const agreeTermsAndConditionChanged = () => {
    setAgreeTermsAndCondition(!agreeTermsAndCondition);
  };

  const createSelfProvisionWASave = (e) => {
    let areThereErrors = forceValidation(undefined, undefined, 'userSignupForm') || !agreeTermsAndCondition;
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      setLoadingClass('loading');
      if (isUserSignupSaving) {
        return true;
      }
      let cb = (result, response, errorCode) => {
        setIsUserSignupSaving(false);
        if (result) {
          setAuthenticationDetails(response.sessionToken, response.serverTimeUtc, response.subscribeKey);
          redirectToInternalLink('/login');
          window.$('#overlay').show(); //this is being added so login page is not flicker for half second
        }
      };
      setIsUserSignupSaving(true);
      dispatch(
        createSignup(
          {
            jwtEmail,
            isValid,
            isUserSignupSaving,
            firstName,
            lastName,
            email,
            password,
            agreeTermsAndCondition,
            timeZone,
          },
          cb
        )
      );
    }
  };

  let spaceBWFields = 'mrtl';
  let areThereErrors = !agreeTermsAndCondition;
  if (agreeTermsAndCondition) {
    //this is important as on checkbox check we want to see if there is any other error
    //passing false to the last param means we will nto display the error icons
    areThereErrors = forceValidation(undefined, undefined, 'userSignupForm', undefined, false);
  }

  let savebuttonClass =
    'mrtml ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbl ';
  savebuttonClass = !areThereErrors ? savebuttonClass : savebuttonClass + ' disable termsAndConditionNotAccepted ';

  let conditionalControls = '';
  if (isValid) {
    conditionalControls = (
      <div className="pdts mrbml">
        <ValidMe validmefor="nonLetterNonNumber" trim={true} group="userSignupForm">
          <Txt
            tabIndex="1"
            focusme="true"
            noTitle
            value={firstName}
            onChange={firstNameChanged}
            placeholder={APP.LANGUAGE.SelfProvisionCreateWA.FirstName}
          />
        </ValidMe>
        <ValidMe validmefor="nonLetterNonNumber@optional" trim={true} group="userSignupForm">
          <Txt
            tabIndex="2"
            fieldClasses={spaceBWFields}
            noTitle
            value={lastName}
            onChange={lastNameChanged}
            placeholder={APP.LANGUAGE.SelfProvisionCreateWA.LastName}
          />
        </ValidMe>

        <label className={'placeholder-label  no-bold color-placeholder mrtnull pdtnull emailLabel'}>
          {APP.LANGUAGE.SelfProvisionCreateWA.EmailAddress}
        </label>
        <div className="mrls color-white mrtl">{' ' + email}</div>

        <ValidMe
          validmefor="condition"
          getTemplatedError={(value) => {
            return passwordValidator.getErrorStyles(value || password);
          }}
          condition={(value) => {
            //if all password strength conditions are good, returns true. else returns false.
            var np = value || password;
            if (
              !passwordValidator.verifyPasswordLength(np) ||
              !passwordValidator.verifyPasswordStrengthLetter(np) ||
              !passwordValidator.verifyPasswordStrengthNumber(np) ||
              !passwordValidator.verifyPasswordStrengthSpecialCharacter(np)
            )
              return false;
            else {
              passwordValue = np;
              return true;
            }
          }}
          group="userSignupForm"
        >
          <Txt
            tabIndex="3"
            fieldClasses="mrtmll "
            noTitle
            type="password"
            value={password}
            onChange={passwordChanged}
            placeholder={APP.LANGUAGE.SelfProvisionCreateWA.Password}
          />
        </ValidMe>
        <ValidMe
          validmefor="condition"
          validmemessagecondition={APP.LANGUAGE.ResetPassword.ConfirmPasswordNotSame}
          group="userSignupForm"
          condition={(confirmPasswordValue) => {
            return passwordValue == confirmPasswordValue;
          }}
        >
          <Txt
            tabIndex="4"
            fieldClasses={spaceBWFields}
            noTitle
            type="password"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={retypePasswordChanged}
            placeholder={APP.LANGUAGE.SelfProvisionCreateWA.RetypePassword}
          />
        </ValidMe>
      </div>
    );
  }

  savebuttonClass = isUserSignupSaving ? savebuttonClass + ' loading' : savebuttonClass;
  return (
    <div className="selfProvisionBackGround">
      <div className="ui form pdlm pdrm" data-show={isValid}>
        <div>
          <img style={{ width: '100%' }} src={window.APP.IMAGES.ApplicationLogo} />
        </div>
        <div className="bold mrbl color-white  mrtl text-size-xl txt-centered ">
          {APP.LANGUAGE.UserSignUp.SignupHeader}
        </div>
        {conditionalControls}
        <div>
          <Checkbox
            checked={agreeTermsAndCondition}
            onChange={agreeTermsAndConditionChanged}
            label={APP.LANGUAGE.SelfProvisionCreateWA.AgreeTermsLabel}
          />
          <span class="color-white">
            {' '}
            <a target="mgt-console-help" href="/terms">
              {APP.LANGUAGE.SelfProvisionCreateWA.TermsCondition}
            </a>{' '}
            {APP.LANGUAGE.SelfProvisionCreateWA.And}{' '}
            <a target="mgt-console-help" href={APP.EXTERNAL_LINKS.Login.PrivacyPolicy}>
              {APP.LANGUAGE.SelfProvisionCreateWA.PrivacyPolicy}
            </a>{' '}
            {APP.LANGUAGE.SelfProvisionCreateWA.acknowledge.replace(
              '##PortalName##',
              window.APP.CONFIGURATION.PORTAL.HostPlatformName
            )}
            <a target="mgt-console-help" href="/cookies">
              {APP.LANGUAGE.SelfProvisionCreateWA.CookiePolicy}
            </a>
            {'.'}
          </span>
        </div>
        <button
          type="button"
          data-group="selfProvisionWAForm"
          onClick={createSelfProvisionWASave}
          className={`${savebuttonClass} ${loadingClass}`}
        >
          <i className="checkmark  icon" />
          <span className="smallOnMobile">{APP.LANGUAGE.UserSignUp.SignUpButton}</span>
        </button>
      </div>
    </div>
  );
};

export default ContentUserSignUp;
